import React, { Component } from 'react';
import {
    NavBar,
    BreadCumb,
    TimeOut,
    ClientsModal,
    InitialCashModal,
    CashCutModal,
    AuthorizationModel,
    WarningModal,
    ToolTip
} from '../../components';
import { CURRENCY, DISPATCH_ID, SERVICE_RESPONSE, SYMBOL, Modules } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import config from '../../config';
import '../../css/tablesPOS.css';
import moment from 'moment';
import { ApiClient } from '../../libs/apiClient';
import { PdfViewer, GeneralFunctions } from "../../components/index";
import { BusinessPartnerPS, Addresses, NewOrderSales } from "../../components/NewOrder";
import $ from "jquery";
import socketService from '../../libs/sockets/SocketService';
import { ToolTips } from '../../libs/utils/Const';
import PrintDocumentsModal from '../../components/PrintDocumentsModal';
import printerService from '../../libs/printer/PrinterService';
import { getFriendlyPrinterError } from '../../libs/printer/WebSerialPrinter';
const tips = ToolTips.Reprint;
let _generalFunctions = new GeneralFunctions();

let apiClient = ApiClient.getInstance();
const PRINT_SERIES_FIELD_BY_DOC_TYPE = {
    IV: 'U_FMB_ValidateSeriesOINV',
    IVR: 'U_FMB_ValidateSeriesOINV',
    IVH: 'U_FMB_ValidateSeriesOINV',
    IVCU: 'U_FMB_ValidateSeriesORCT',
    DL: 'U_FMB_ValidateSeriesODLN',
    DLR: 'U_FMB_ValidateSeriesODLN',
    // DH: 'U_FMB_ValidateSeriesODLN',
    DHP: 'U_FMB_ValidateSeriesODLN',
    // OR: 'U_FMB_ValidateSeriesORDR',
    // QT: 'U_FMB_ValidateSeriesOQUT',
    IP: 'U_FMB_ValidateSeriesORCT',
    // RT: 'U_FMB_ValidateSeriesORDN',
    // CN: 'U_FMB_ValidateSeriesORIN',
    // DP: 'U_FMB_ValidateSeriesODPI',
    GRE: 'U_FMB_ValidateSeriesOWTR',
};
const PRINT_SERIES_FIELD_BY_TICKET_TYPE = {
    GoodsReceipt: 'U_FMB_ValidateSeriesOPDN',
    transfers: 'U_FMB_ValidateSeriesOWTR',
    transfersOutput: 'U_FMB_ValidateSeriesOIGE',
};

const getPrintSeriesField = (typeDoc, ticketDocType) => {
    if (typeDoc === 'TCK') return PRINT_SERIES_FIELD_BY_TICKET_TYPE[ticketDocType] || '';
    return PRINT_SERIES_FIELD_BY_DOC_TYPE[typeDoc] || '';
};

const hasConfiguredPrintSeries = (series) => String(series || '')
    .split('|')
    .some(value => /^\d+$/.test(value.trim()));

const getConfiguredPrintSeries = (series) => new Set(
    String(series || '')
        .split('|')
        .map(value => value.trim())
        .filter(value => /^\d+$/.test(value))
        .map(value => String(Number(value)))
);

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};


class RePrintView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            initialDate: moment(new Date()).format("YYYY-MM-DD"),
            finalDate: moment(new Date()).format("YYYY-MM-DD"),
            searchByBO: true,
            module: 0,
            typeDoc: '',
            typeDoc2: '',
            folio: '',
            cardCode: '',
            docs: [],
            checkboxDataTables: (new Map()),
            //info to print
            mailsTo: [],
            sendMailModel: {
                to: '',
                subject: '',
            },
            showPDFViewer: false,
            docsToPrint: [],
            venta: [
                { value: 'DL', name: 'Venta de caja (ticket).', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'DH', name: 'Venta a domicilio.', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'IVH', name: 'Factura a domicilio.', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'OR', name: 'Pedido.', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'QT', name: 'Cotizaciones.', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'IV', name: 'Factura.', permissions: ['manager', 'counter', 'cashRegister'] },
                // { value: 'IVAP', name: 'Factura Aplicación de anticipo' },
                { value: 'IP', name: 'Cobranza.', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'RT', name: 'Devoluciones.', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'CN', name: 'Notas de crédito.', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'DP', name: 'Factura de anticipo.', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'IVR', name: 'Factura de reserva.', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'DLR', name: 'Entregas de factura de reserva.', permissions: ['manager', 'counter', 'cashRegister', 'storer'] },
                { value: 'IVCU', name: 'Cesión en uso.', permissions: ['manager', 'counter', 'cashRegister'] },
                { value: 'GRE', name: 'Guía de remisión electrónica.', permissions: ['manager', 'counter', 'cashRegister'] },
                ...(Modules.Ticket ? [{ value: 'TCK', name: 'Ticket.', permissions: ['manager', 'counter', 'cashRegister'] }] : []),
                // { value: 'MI', name: 'Entrada de dinero.' },
                // { value: 'MO', name: 'Salida de dinero.' },
                // { value: 'DHP', name: 'Venta a domicilio pagada. (ticket)' },
                // { value: 'SC', name: 'Envío a mostrador. (ticket)' },

                // { value: 'DD', name: 'Entrega directa.' },
                // { value: 'JE', name: 'Depósitos bancarios.' },
            ],
            ticketDocType: '',
            ticketOptions: [
                { value: 'GoodsReceipt', name: 'Entrada de mercancía de compras' },
                { value: 'transfers', name: 'Traslado de mercancía' },
                { value: 'transfersOutput', name: 'Salida de mercancía' },
            ],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            // re-billing 
            showInitialCashModal: false,
            showClientsModal: false,
            actionButton: true,
            CanChangePartner: true,
            idWorkShift: "",
            partnerSearch: "",
            folioToSearch: '',
            setDeliveryIndex: '',
            setBillIndex: '',
            suggestions: [],
            businessPartners: [],
            deliveryAddresses: [],
            billAddresses: [],
            groupNumList: [],
            editModePartner: false,
            partnerIndex: 0,
            businessPartner: new BusinessPartnerPS(),
            auxBusinessPartner: new BusinessPartnerPS(),
            updatebusinessPartner: new BusinessPartnerPS(),
            newOrderModel: new NewOrderSales(),
            addressModel: new Addresses(),
            auxAddressModel: new Addresses(),
            pointer: 1,
            Action: 1,
            NextStepFunction: () => { },

            showCashCutModal: false,
            lastDaySession: false,
            printhide: true,
            cashCut: {},
            objCharge: {},
            extraPaymentsCashCut: {},
            totalCashCut: 0,
            TotalAmountSales: 0,
            numSalesCashCut: 0,
            moneyEntries: [],
            moneyOuts: [],

            AuthorizationComments: [],
            CFDI: [],
            RegimenFiscal: [],
            ReturnedBlindCut: [],
            taxes: [],
            states: [],
            countries: [],
            bankOptions: [],

            showWarningModal: false,
            showBillingBtn: false,
        }
    }

    componentDidMount = async () => {
        this._handelBack();

        await this.CheckWorkSession();
        await this.GetUseCFDI();
        await this.GetRegimenFiscal();
        await this.FilterRequestDocs();
        await this.GetTaxes('deliveries');
        await this.GetCountriesAndStates();

    }

    //#region ######### Taxes Delivery, countries ann deliveries states ################################################
    GetTaxes = async type => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        const groupCodeResponse = await apiClient.getTaxesList();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información de impuestos' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            taxes: groupCodeResponse.data,
            countryIndexSelected: type,
        });

    };

    GetCountriesAndStates = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { countries, states } = this.state
        if (countries.length > 0 && states.length > 0) return

        enableSpinner(true);
        const responseApi = await apiClient.getDataEmployee();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'warning', message: responseApi.message });
            return;
        }

        await this.setState({
            states: responseApi.data.states || [],
            countries: responseApi.data.country || []
        })
    }

    searchBanksOptions = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let banksRes = await apiClient.getBanksOptions();
        enableSpinner(false);
        if (!banksRes?.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: banksRes?.message || "Ocurrió un error al obtener el listado de bancos dispobiles para los depósitos" });
        } else {
            this.setState({
                bankOptions: banksRes?.data ?? []
            })
        }
    }

    //#endregion

    ChanceTemporalDataToFalse = async () => {
        await this.setState({
            showTemporalData: false
        })
    }


    FilterRequestDocs = async () => {
        const { venta, _user } = this.state;
        let auxArrayAccess = [];
        for (let DARWIN = 0; DARWIN < venta.length; DARWIN++) {
            const document = venta[DARWIN];
            if (await document.permissions.includes(`${_user?.U_FMB_CounterRol}`)) {
                auxArrayAccess.push(document)
            }
        }
        await this.setState({
            venta: auxArrayAccess || []
        })
    }

    GetUseCFDI = async () => {
        let cfdi = await apiClient.getUsoCFDI();
        if (Array.isArray(cfdi.data) && cfdi.data.length) {
            this.setState({
                CFDI: cfdi.data,
            });
        }
    };

    GetRegimenFiscal = async () => {
        let regimenFiscal = await apiClient.getRegimenFiscal();

        if (Array.isArray(regimenFiscal.data) && regimenFiscal.data.length) {
            this.setState({
                RegimenFiscal: regimenFiscal.data,
            });
        }
    };

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    CheckWorkSession = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.checkWorkSession();
        enableSpinner(false);

        if (responseApi.status === 1) {
            if (!responseApi.data.sessionStatus) {
                await this.ShowInitialCash();
            } else {
                if (responseApi.data.NotCashCut === true) {
                    showAlert({ type: "info", message: `${responseApi.message}. Realiza tu corte para continuar`, timeout: 100000 });
                    await this.setState({
                        idWorkShift: responseApi.data.idSession,
                        lastDaySession: true,
                    });
                    await this.ShowCashCutModal();
                    $("#cashCutModal").modal("show");
                } else {
                    await this.setState({
                        idWorkShift: responseApi.data.idSession
                    });
                }
            }
        } else if (responseApi.status === 2) {
            showAlert({ type: "info", message: `${responseApi.message}`, timeout: 10000 });
            this.GotoDashboard();
        }
    };

    ShowCashCutModal = async () => {
        await this.setState({
            showCashCutModal: !this.state.showCashCutModal,
        });
        if (this.state.showCashCutModal) await this.GetBoxCut();
        if (!this.state.showCashCutModal) $("#cashCutModal").modal("hide");

    };

    ShowCashCutModal = async () => {
        await this.setState({
            showCashCutModal: !this.state.showCashCutModal,
        });
        if (this.state.showCashCutModal) await this.GetBoxCut();

    };

    ShowInitialCash = async () => {
        await this.setState({
            showInitialCashModal: !this.state.showInitialCashModal,
        });
        $("#initialCashModal").modal("show");
    };

    ChangeInitialDate = async (event) => {
        let initialDate = event.nativeEvent.target.value;
        await this.setState({
            initialDate,
        });
    };

    ChangeFinalDate = async (event) => {
        const { initialDate } = this.state;
        let finalDate = event.nativeEvent.target.value;
        // if (finalDate < initialDate) {
        //     return;
        // }
        await this.setState({
            finalDate,
        });
    };

    ChangeSearchByBranchOffice = async () => {
        await this.setState({
            searchByBO: !this.state.searchByBO
        })
        await this.SearchPrintReports()
    }

    OnchangeModulePSearch = (event) => {
        this.setState({ module: Number(event) })
    }

    OnchangeTypeDoc = async (value) => {
        await this.setState({
            typeDoc: value,
            folio: '',
            typeDoc2: value,
            ticketDocType: '',
            docs: [],
            checkboxDataTables: (new Map()),
        })
        if (value !== 'TCK') {
            this.SearchPrintReports();
        }
    }

    OnchangeTicketDocType = async (value) => {
        await this.setState({ ticketDocType: value })
        this.SearchPrintReports();
    }

    OnchangeCardCode = (value) => {
        this.setState({ cardCode: value })
    }

    OnchangeFolio = (value) => {
        this.setState({ folio: value })
        this.setState({ newOrderModel: { TckFolio: value } })
    }

    OnchangePDfViewer = () => {
        this.setState({ showPDFViewer: !this.state.showPDFViewer })
        this.setState({ newOrderModel: { TckFolio: "" } })
    }

    refreshModel = (OrderModel) => {
        this.setState({ newOrderModel: OrderModel })
    }

    SearchPrintReports = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { initialDate, finalDate, typeDoc, folio, cardCode, searchByBO, ticketDocType, _user } = this.state

        if (typeDoc === '' && folio === '') {
            showAlert({ type: "error", message: `DEBES SELECCIONAR EL TIPO DE DOCUMENTO A BUSCAR` });
            return;
        }
        if (cardCode !== '' && typeDoc === '') {
            showAlert({ type: "error", message: `DEBES SELECCIONAR EL TIPO DE DOCUMENTOS A BUSCAR CON ESE CARDCODE` });
            return;
        }

        if (typeDoc === 'TCK' && !ticketDocType) {
            showAlert({ type: "error", message: `DEBES SELECCIONAR EL TIPO DE TIKET A BUSCAR` });
            return;
        }
        const seriesField = getPrintSeriesField(typeDoc, ticketDocType);

        if (seriesField && !hasConfiguredPrintSeries(_user?.[seriesField])) {
            showAlert({ type: 'warning', message: `El usuario no tiene series permitidas para este tipo de documento (${seriesField})` });
            await this.setState({ docs: [], checkboxDataTables: new Map() });
            return;
        }

        const data = {
            typeDoc: typeDoc,
            initialDate: initialDate,
            finalDate: finalDate,
            folio: folio,
            cardCode: cardCode,
            searchByBO,
            ticketDocType: typeDoc === 'TCK' ? ticketDocType : ''
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintReports(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: responseApi.message });
            return;
        }

        let resData = Array.isArray(responseApi.data) ? responseApi.data : [];

        if (seriesField && resData.length > 0) {
            const responseHasSeries = resData.every(document => document?.Series !== undefined && document?.Series !== null);
            if (!responseHasSeries) {
                showAlert({ type: 'info', message: `No tienes documentos disponibles para las series asignadas a tu sucursal.` });
                await this.setState({ docs: [], checkboxDataTables: new Map() });
                return;
            }

            const configuredSeries = getConfiguredPrintSeries(_user?.[seriesField]);
            resData = resData.filter(document => configuredSeries.has(String(Number(document.Series))));
        }

        if (resData.length === 0) {
            showAlert({ type: "info", message: `NO HAY INFO CON ESOS PARÁMETROS DE BÚSQUEDA` });
            await this.setState({
                docs: [],
                checkboxDataTables: (new Map()),
                partnerSearch: ''
            });

            return;
        } else if (resData.some(doc => Number(doc.docObjectType) === 203)) {
            await this.setState({ typeDoc: 'DP' });
        } else if (resData.some(({ docObjectType, isIns }) => Number(docObjectType) === 15 && isIns === 'Y')) {
            await this.setState({ typeDoc: 'DLR', typeDoc2: 'DLR' });
        }

        await this.setState({ showBillingBtn: Number(resData[0]?.docObjectType) === 15 });
        await this.setState({
            docs: resData || [],
            checkboxDataTables: (new Map()),
            partnerSearch: resData[0].cardCode || '',
            folioToSearch: resData[0].folio || ''
        });

    }

    RegisterReprint = async (array) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let data = [];

        for (let index = 0; index < array.length; index++) {
            data[index] = {
                docFolio: array[index].hasOwnProperty('docHeader') ? array[index].docHeader.infoByFolio.folio : array[index].header.U_FMB_FOLIO_COUNTER,
                cardCode: array[index].hasOwnProperty('docHeader') ? array[index].docHeader.responseHeader.CardCode : array[index].header.CardCode,
                cardName: array[index].hasOwnProperty('docHeader') ? array[index].docHeader.responseHeader.CardName : array[index].header.CardName,
                rePrintDate: moment(new Date()).format('YYYY-MM-DD'),
                rePrinTime: moment(new Date()).format('HH:mm:ss'),
                codeSuc: this.state._user?.Sucursal,
                idSession: this.state.idWorkShift,
            }

        }

        enableSpinner(true);
        let responseApi = await apiClient.setRegisterReprint(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: responseApi.message });
            return;
        }
    }

    toggleDocumentSelected = (id) => {
        this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(id, !checkboxDataTables.get(id)); // toggle
            return { checkboxDataTables };
        });
    };

    BuildCertificateReference = (doc, typeDoc) => {
        if (!doc) return '';
        return `${typeDoc ?? ''}-${doc.U_BPP_MDSD ?? ''}-${doc.U_BPP_MDCD ?? ''}`;
    }

    BuildDocumentReference = (doc, typeDoc) => {
        if (!doc) return '';
        if ((typeDoc ?? this.state.typeDoc) === 'IV') {
            if (doc.NumAtCard) return doc.NumAtCard;
            return doc.folio ?? '';
        }
        return this.BuildCertificateReference(doc, typeDoc ?? this.state.typeDoc);
    }

    ReprintSelectedTickets = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { typeDoc, checkboxDataTables, docs, _user } = this.state;

        if (typeDoc !== 'IV' && typeDoc !== 'TCK') return;

        if (typeDoc === 'TCK') {
            const documents = [];
            for (let [id, value] of this.state.checkboxDataTables.entries()) {
                if (value) {
                    const doc = this.state.docs[id];
                    documents.push({
                        DocEntry: doc.docEntry,
                        ObjType: doc.docObjectType
                    });
                }
            }

            if (documents.length === 0) {
                showAlert({ type: "info", message: `SELECCIONA UN DOCUMENTO PARA PODER CONTINUAR` });
                return;
            }

            enableSpinner(true);
            const responseApi = await apiClient.printTicketDocs({
                documents,
                ticketDocType: this.state.ticketDocType,
                action: 'reprintTicket'
            });
            enableSpinner(false);

            if (responseApi.status !== SERVICE_RESPONSE.SUCCESS) {
                showAlert({ type: "error", message: responseApi?.message || "Ocurrió un error inesperado" });
                return;
            }

            try {
                const documents = Array.isArray(responseApi.data) ? responseApi.data : [];
                const printResult = await printerService.printTickets(_user, documents, { remember: false });

                // await this.RegisterReprint(documents);
                showAlert({ type: 'success', message: printResult.count === 1 ? 'Ticket reimpreso correctamente' : `${printResult.count} tickets reimpresos correctamente` });

            } catch (error) {
                return showAlert({ type: 'error', message: error.message ?? 'No puedes visualizar el PDF' });
            }
            return;
        }

        const selectedDocuments = [];
        for (const [index, selected] of checkboxDataTables.entries()) {
            if (selected && docs[index]) selectedDocuments.push(docs[index]);
        }

        if (selectedDocuments.length === 0) {
            showAlert({ type: 'info', message: 'Selecciona una factura para reimprimir su ticket' });
            return;
        }

        const folios = selectedDocuments
            .map((document) => document.NumAtCard || document.folio)
            .filter(Boolean);

        if (folios.length !== selectedDocuments.length) {
            showAlert({ type: 'error', message: 'No se encontro el folio de una de las facturas seleccionadas' });
            return;
        }

        enableSpinner(true);
        try {
            const responseApi = await apiClient.getPrintDocsInfo({
                docsToPrintIds: folios,
                typeDoc: 'IV'
            });

            if (responseApi.status !== SERVICE_RESPONSE.SUCCESS) {
                showAlert({ type: 'error', message: responseApi.message || 'No se pudo consultar la factura' });
                return;
            }

            const invoiceDocuments = Array.isArray(responseApi.data) ? responseApi.data : [];
            if (invoiceDocuments.length === 0) {
                showAlert({ type: 'error', message: 'La consulta no devolvio información para imprimir el ticket' });
                return;
            }

            if (invoiceDocuments.length !== selectedDocuments.length) {
                showAlert({ type: 'error', message: `Se seleccionaron ${selectedDocuments.length} facturas, pero solamente se obtuvo informacion de ${invoiceDocuments.length}. No se imprimio el lote.` });
                return;
            }

            const printResult = await printerService.printInvoices(_user, invoiceDocuments, { remember: false });

            await this.RegisterReprint(invoiceDocuments);
            showAlert({ type: 'success', message: printResult.count === 1 ? 'Ticket reimpreso correctamente' : `${printResult.count} tickets reimpresos correctamente` });
        } catch (error) {
            showAlert({ type: 'error', message: getFriendlyPrinterError(error) });
        } finally {
            enableSpinner(false);
        }
    }

    SendToPrint = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { typeDoc } = this.state;
        let foliosDocs = []; let auxTypeDoc = '';
        for (let [id, value] of this.state.checkboxDataTables.entries()) {
            if (value) {
                const doc = this.state.docs[id];
                if (typeDoc === 'IVCU' || typeDoc === 'IP') {
                    foliosDocs.push(this.BuildCertificateReference(doc, typeDoc));
                } else if (typeDoc === 'IV') {
                    foliosDocs.push(doc.NumAtCard || doc.folio);
                } else {
                    foliosDocs.push(doc.folio);
                }
            }
        }
        if (foliosDocs.length === 0) {
            showAlert({ type: "error", message: `SELECCIONA UN DOCUMENTO PARA PODER CONTINUAR` });
            return
        }

        if (typeDoc === 'GRE') {
            const documents = [];
            for (let [id, value] of this.state.checkboxDataTables.entries()) {
                if (value) {
                    const doc = this.state.docs[id];
                    documents.push({
                        DocEntry: doc.docEntry,
                        ObjType: doc.docObjectType ?? '67'
                    });
                }
            }

            enableSpinner(true);
            const responseApi = await apiClient.printGREDocs({ documents, action: 'print' });
            enableSpinner(false);

            if (responseApi.status !== SERVICE_RESPONSE.SUCCESS) {
                showAlert({ type: "error", message: responseApi?.message || "Ocurrió un error inesperado" });
                return;
            }

            try {
                const pdfViewer = document.getElementById('pdfPrinterViewer');
                const base64 = responseApi?.data?.[0]?.file;

                if (!pdfViewer || !base64) {
                    return showAlert({ type: 'error', message: 'No se encontró el archivo PDF' });
                }

                pdfViewer.innerHTML = `
            <div style="background:#2b2b2b; padding:20px; border-radius:10px; height:100%;">
                <iframe 
                    src="data:application/pdf;base64,${base64}"
                    style="width: 100%; height: 100%; border: none;">
                </iframe>
            </div>
        `;
                $("#printDocumentsModal").modal("show");
            } catch (error) {
                return showAlert({ type: 'error', message: error.message ?? 'No puedes visualizar el PDF' });
            }
            return;
        }

        if (typeDoc === 'IVCU') {
            const documents = [];
            for (let [id, value] of this.state.checkboxDataTables.entries()) {
                if (value) {
                    const doc = this.state.docs[id];
                    documents.push({
                        DocEntry: doc.docEntry,
                        ObjType: doc.docObjectType ?? '13'
                    });
                }
            }

            enableSpinner(true);
            const responseApi = await apiClient.printCesionEnUsoDocs({ documents, action: 'print' });
            enableSpinner(false);

            if (responseApi.status !== SERVICE_RESPONSE.SUCCESS) {
                showAlert({ type: "error", message: responseApi?.message || "Ocurrió un error inesperado" });
                return;
            }

            try {
                const pdfViewer = document.getElementById('pdfPrinterViewer');
                const base64 = responseApi?.data?.[0]?.file;

                if (!pdfViewer || !base64) {
                    return showAlert({ type: 'error', message: 'No se encontró el archivo PDF' });
                }

                pdfViewer.innerHTML = `
                <div style="background:#2b2b2b; padding:20px; border-radius:10px; height:100%;">
                    <iframe 
                        src="data:application/pdf;base64,${base64}"
                        style="width: 100%; height: 100%; border: none;">
                    </iframe>
                </div>
            `;
                $("#printDocumentsModal").modal("show");
            } catch (error) {
                return showAlert({ type: 'error', message: error.message ?? 'No puedes visualizar el PDF' });
            }
            return;
        }

        if (typeDoc === 'TCK') {
            const documents = [];
            for (let [id, value] of this.state.checkboxDataTables.entries()) {
                if (value) {
                    const doc = this.state.docs[id];
                    documents.push({
                        DocEntry: doc.docEntry,
                        ObjType: doc.docObjectType
                    });
                }
            }

            if (documents.length === 0) {
                showAlert({ type: "info", message: `SELECCIONA UN DOCUMENTO PARA PODER CONTINUAR` });
                return;
            }

            enableSpinner(true);
            const responseApi = await apiClient.printTicketDocs({
                documents,
                ticketDocType: this.state.ticketDocType,
                action: 'print'
            });
            enableSpinner(false);

            if (responseApi.status !== SERVICE_RESPONSE.SUCCESS) {
                showAlert({ type: "error", message: responseApi?.message || "Ocurrió un error inesperado" });
                return;
            }

            try {
                const pdfViewer = document.getElementById('pdfPrinterViewer');
                const base64 = responseApi?.data?.[0]?.file;

                if (!pdfViewer || !base64) {
                    return showAlert({ type: 'error', message: 'No se encontró el archivo PDF' });
                }

                pdfViewer.innerHTML = `
                <div style="background:#2b2b2b; padding:20px; border-radius:10px; height:100%;">
                    <iframe 
                        src="data:application/pdf;base64,${base64}"
                        style="width: 100%; height: 100%; border: none;">
                    </iframe>
                </div>
            `;
                $("#printDocumentsModal").modal("show");
            } catch (error) {
                return showAlert({ type: 'error', message: error.message ?? 'No puedes visualizar el PDF' });
            }
            return;
        }

        auxTypeDoc = await _generalFunctions.getDocInfoByFolio(foliosDocs[0])

        const data = {
            docsToPrintIds: foliosDocs,
            typeDoc: auxTypeDoc.num
        }
        enableSpinner(true);
        let responseApi = [];

        if (auxTypeDoc.num === 24) {
            let collection = [];
            let flag = false;
            for (let index = 0; index < foliosDocs.length; index++) {
                const folio = foliosDocs[index];
                let info = {
                    doc: folio.substring(5, 50),
                    table: 'ORCT',
                    docSubType: "--",
                    view: "payment",
                    view2: "payment"
                };
                responseApi = await apiClient.getDocumentsDetails(info);
                if (responseApi.status === 1) {
                    flag = true;
                    responseApi.data.header.folio = folio;
                    collection.push(responseApi.data);
                }
            }
            if (flag) {
                responseApi.data = collection;
            }
        } else {
            responseApi = await apiClient.getPrintDocsInfo(data);
        }
        // return
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }

        await this.OnchangePDfViewer();
        await this.setState({
            docsToPrint: responseApi.data || [],
            typeDoc: auxTypeDoc.folioID === 'DH' ? 'ODLD' : auxTypeDoc.table
        });
        $("#pdfViewer").modal("show");

    }

    CleanCheckedList = () => {
        this.setState({
            folio: '',
            cardCode: '',
            docs: [],
            checkboxDataTables: (new Map()),
            showPDFViewer: false,
            docsToPrint: [],
            typeDoc: '',


        });
    }

    OpenSendMailModal = () => {
        $("#pdfSendMailModal").modal("show");
    }

    //#region ########## Mail Functions #####################################################
    SendDocsMail = () => {
        const { sendMailModel } = this.state
    }

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    }

    SendDocsByEmail = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDoc } = this.state;
        try {
            let infoDoc = [];
            for (let index = 0; index < docsToPrint.length; index++) {
                const document = docsToPrint[index];
                let newInfoDoc = {
                    cardCode: document?.docHeader ? document?.docHeader?.responseHeader?.CardCode : document?.header?.CardCode || '',
                    folio: document?.docHeader ? document?.docHeader?.infoByFolio?.folio || document?.docHeader?.responseHeader?.infoByFolio?.folio : document?.header?.folio || '',
                    docEntry: document?.docHeader ? document?.docHeader?.responseHeader?.DocEntry : document?.header?.DocEntry || '',
                    slpInfo: {
                        slpCode: document?.docHeader ? document?.docHeader?.responseHeader?.SlpCode : document?.header?.SlpCode || '',
                        slpName: document?.docHeader ? document?.docHeader?.responseHeader?.SlpName : document?.header?.SlpName || '',
                    }
                }
                infoDoc.push(newInfoDoc);
            }
            let data = {
                sendMailModel,
                typeDoc: typeDoc,
                infoDoc
            }

            enableSpinner(true);
            let responseApi = await apiClient.SendPrintDocsByEmail(data);

            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
                return;
            }
            showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
        } catch (error) {
            console.error("Error en SendDocsByEmail:", error);
            showAlert({ type: "error", message: error?.message || "Ocurrió un error al enviar el documento por correo" });
        } finally {
            enableSpinner(false);
        }
    }
    //#endregion

    //#region ##### RE BILLING FUNCTIONS ############################################## ✔
    EnableClientsModal = async () => {
        await this.setState({
            showClientsModal: !this.state.showClientsModal,
        });
    };

    RefreshBusinessModel = async (updatebusinessPartner) => {
        await this.setState({ updatebusinessPartner })
    };

    ChangePartnerSearch = async (value) => {
        this.setState({
            partnerSearch: value,
        });
    };

    RefreshBusinessPartner = async (newBusinessPartner) => {
        this.setState({ businessPartners: newBusinessPartner });
    };

    CheckIfItsUniversalPartner = async () => {
        const { _user, newOrderModel } = this.state;
        let flag = true;
        if (_user?.Partner !== null && _user?.Partner !== undefined && _user?.Partner !== '') {
            if (newOrderModel.CardCode !== _user?.Partner.CardCode) {
                flag = false;
            } else {
                flag = true;
            }
        }
        await this.setState({ isUniversal: flag })
        return flag
    }

    SelectPartnerIndex = async (index) => {
        const { businessPartners } = this.state;
        await this.setState({
            partnerIndex: index,
            updatebusinessPartner: businessPartners[index],

        });
        this.GetPartnerAddresses(this.state.updatebusinessPartner.CardCode);
    };

    SearchPartners = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { partnerSearch } = this.state;

        if (!partnerSearch || partnerSearch.length < 2) {
            showAlert({ type: "warning", message: "Cliente no encontrado" });
            await this.setState({ suggestions: [] });
            return;
        }

        enableSpinner(true);
        let getPartnersResponse = await apiClient.SearchPartner(partnerSearch);
        enableSpinner(false);

        if (!Array.isArray(getPartnersResponse.data)) {
            showAlert({ type: "error", message: getPartnersResponse.message });
            return;
        }

        if (getPartnersResponse.data.length === 0) {
            showAlert({ type: "info", message: "No hay Información por mostrar" });
            return;
        }

        if (getPartnersResponse.data.length === 1) {
            $("#clientsModal").modal("hide");
            await this.setState({
                businessPartners: getPartnersResponse.data,
                ItsComingOfRebilling: true,
            });

            await this.SelectBusinessPartner();
        } else {
            this.setState({
                businessPartners: getPartnersResponse.data,
            });
        }

    };

    FillAddressesByBP = async (deliveriesAddress, billAddresseses) => {
        let deliveryAddresses = [];
        let billAddresses = [];
        for (const address of deliveriesAddress) {
            let addressModel = new Addresses();
            addressModel.Address = address.Address;
            addressModel.Street = address.Street;
            addressModel.Block = address.Block;
            addressModel.City = address.City;
            addressModel.ZipCode = address.ZipCode;
            addressModel.County = address.County;
            addressModel.State = address.State;
            addressModel.Country = address.Country;
            addressModel.TaxCode = address.TaxCode;
            addressModel.StreetNo = address.StreetNo;

            addressModel.Building = address.Building;
            addressModel.GlblLocNum = address.GlblLocNum;
            addressModel.TaxOffice = address.TaxOffice;
            addressModel.TypeOfAddress = address.AdresType;
            addressModel.LineNum = address.LineNum;
            deliveryAddresses.push(addressModel);
        }
        for (const billAddress of billAddresseses) {
            let addressModel = new Addresses();
            addressModel.Address = billAddress.Address;
            addressModel.Street = billAddress.Street;
            addressModel.Block = billAddress.Block;
            addressModel.City = billAddress.City;
            addressModel.ZipCode = billAddress.ZipCode;
            addressModel.County = billAddress.County;
            addressModel.State = billAddress.State;
            addressModel.Country = billAddress.Country;
            addressModel.TaxCode = billAddress.TaxCode;
            addressModel.StreetNo = billAddress.StreetNo;

            addressModel.Building = billAddress.Building;
            addressModel.GlblLocNum = billAddress.GlblLocNum;
            addressModel.TaxOffice = billAddress.TaxOffice;
            addressModel.TypeOfAddress = billAddress.AdresType;
            addressModel.LineNum = billAddress.LineNum;
            billAddresses.push(addressModel);
        }
        this.setState(
            {
                deliveryAddresses,
                billAddresses,
                setDeliveryIndex: '',
                setBillIndex: '',
            });
    }

    GetPartnerAddresses = async (CardCode) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const data = { cardCode: CardCode }
        enableSpinner(true);
        let responseApi = await apiClient.ValidateBPToDH(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'warning', message: 'ALGO SALIO MAL AL CONSULTAR LAS direcciónES DISPONIBLES' });
            return;
        }
        await this.FillAddressesByBP(responseApi.data.deliveriesAddress, responseApi.data.invoicesAddress);
        $('#detailClientModal').modal('show');

    }

    EditBusinessPartner = async () => {
        let { auxBusinessPartner, updatebusinessPartner, editModePartner } = this.state;

        if (!editModePartner) {
            await this.setState({
                auxBusinessPartner: Object.assign({}, updatebusinessPartner),
                editModePartner: true
            });
        } else if (auxBusinessPartner) {
            await this.setState({
                updatebusinessPartner: Object.assign({}, auxBusinessPartner),
                editModePartner: false
            });
        }
    };

    SelectBusinessPartner = async (index = 0, opcion = null) => {
        const { businessPartners, newOrderModel, _user, ItsComingOfRebilling } = this.state;
        const { notificationReducer: { showAlert } } = this.props;

        if (opcion === 'default') {
            const { Partner } = _user;
            if (!Partner.CardCode) {
                showAlert({ type: 'warning', message: 'No cuenta con un cliente asignado por defecto' });
                return;
            }
            newOrderModel.CardCode = Partner.CardCode;
            newOrderModel.CardName = Partner.CardName;
            newOrderModel.PriceListNum = Partner.ListNum;
            newOrderModel.ShipToDef = Partner.ShipToDef;
            newOrderModel.BillToDef = Partner.BillToDef;
            newOrderModel.Credit = 0;
            newOrderModel.AvailableCredit = 0;
            newOrderModel.IsCredit = false;
            newOrderModel.TaxCode = Partner.TaxCode;
            newOrderModel.TaxRate = Partner.Rate;
            newOrderModel.U_SO1_02METODOPAGO = '';
            newOrderModel.U_FMB_TIPO_REL = '00';
        } else {
            let businessPartner = businessPartners[index];
            newOrderModel.CardCode = businessPartner.CardCode;
            newOrderModel.CardName = businessPartner.CardName;
            newOrderModel.PriceListNum = businessPartner.ListNum;
            newOrderModel.U_FMB_USO_CFDI = businessPartner.U_FMB_USO_CFDI || '';
            newOrderModel.ShipToDef = businessPartner.ShipToDef;
            newOrderModel.BillToDef = businessPartner.BillToDef;
            newOrderModel.PartnerAcctCode = businessPartner.AcctCode;
            newOrderModel.Credit = businessPartner.Credit || 0;
            newOrderModel.AvailableCredit = businessPartner.Credit || 0;
            newOrderModel.IsCredit = false;
            newOrderModel.TaxCode = businessPartner.TaxCode;
            newOrderModel.TaxRate = businessPartner.Rate;

            newOrderModel.PartnerDpmClear = businessPartner.DpmClear;
            newOrderModel.PartnerDpmIntAct = businessPartner.DpmIntAct;
            newOrderModel.U_SO1_02METODOPAGO = businessPartner.GroupNum == '-1' ? 'PUE' : '';

            // Datos para timbrado            
            newOrderModel.USOCFDI = businessPartner.U_FMB_USO_CFDI ?? '';
            newOrderModel.RegimenFiscal = businessPartner.U_FMB_REGIMEN_FISCAL ?? '';
        }
        await this.setState({
            newOrderModel,
            partnerIndex: 0,
            setDeliveryIndex: '',
            setBillIndex: '',
        });
        if (ItsComingOfRebilling) {
            await this.ShowClientsModalReBilling();
            this.GetPartnerAddresses(newOrderModel.CardCode);
        }
    }

    ShowClientsModalReBilling = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state
        enableSpinner(true);
        const getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
        enableSpinner(false);

        if (getPartnersResponse.status !== 1) {
            showAlert({ type: "error", message: `${getPartnersResponse.message}` });
            return;
        }
        await this.setState({
            updatebusinessPartner: getPartnersResponse.data[0],
            NextStepFunction: async () => {
                const { notificationReducer: { showAlert } } = this.props;
                let isAuthorization = await this.ValidateAuthorization();
                if (!isAuthorization) {
                    const isUniversal = await this.CheckIfItsUniversalPartner();
                    if (!isUniversal) {
                        $('#detailClientModal').modal('hide');
                        await this.UploadInvoice();
                    } else {
                        showAlert({ type: "error", message: `NO PUEDES FACTURAR A CON EL CLIENTE DE MOSTRADOR` });
                    }
                }
            }
        })
    }

    ShowChooseDifPartner = async () => {
        $('#detailClientModal').modal('hide');
        $('#clientsModal').modal('show');
    }

    ChangeRegimenFiscal = async (value) => {
        const { newOrderModel, updatebusinessPartner } = this.state;
        updatebusinessPartner.U_FMB_REGIMEN_FISCAL = value
        newOrderModel.RegimenFiscal = value;
        await this.setState({ newOrderModel, updatebusinessPartner });
    };

    ChangeUSOCFDI = async (value) => {
        const { newOrderModel, updatebusinessPartner } = this.state;
        updatebusinessPartner.U_FMB_USO_CFDI = value;
        newOrderModel.USOCFDI = value;
        await this.setState({ newOrderModel, updatebusinessPartner });
    };

    Change_MetodoPago = async (value) => {
        const { newOrderModel } = this.state;
        newOrderModel.U_SO1_02METODOPAGO = value;
        await this.setState({ newOrderModel });
    };

    Change_Tipo_Relacion_CFDI = async (value) => {
        const { newOrderModel } = this.state;
        newOrderModel.U_FMB_TIPO_REL = value;
        await this.setState({ newOrderModel });
    };

    GetDataPartner = async () => {
        let groupNumResponse = await apiClient.getGroupNum();
        if (groupNumResponse.data.length) {
            this.setState({
                groupNumList: groupNumResponse.data,
            });
        }

        let priceListResponse = await apiClient.getPriceList();
        if (priceListResponse.data.length) {
            this.setState({
                priceList: priceListResponse.data,
            });
        }

        let groupCodeResponse = await apiClient.getGroupCode();
        if (groupCodeResponse.data.length) {
            this.setState({
                groupCodeList: groupCodeResponse.data,
            });
        }
    };

    UpdateBusinessPartner = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { updatebusinessPartner } = this.state;
        const data = {
            updatebusinessPartner,
        };
        enableSpinner(true);
        let updateBusinessPartnerResponse = await apiClient.updateBusinessPartnerPS(data);
        enableSpinner(false);

        if (!updateBusinessPartnerResponse.status) {
            showAlert({ type: "error", message: updateBusinessPartnerResponse.message, timeOut: 5000 });
            return;
        }

        showAlert({ type: "success", message: updateBusinessPartnerResponse.message, timeOut: 5000 });

        this.setState({
            editModePartner: false,
        });

    }

    ChangeActionMode = async (value, editMode) => {
        await this.setState({
            Action: value,
            editableMode: editMode
        })
    }

    RefreshAddressModel = async (addressModel) => {
        await this.setState({ addressModel });
    }

    EditAddress = async (value, editMode, index, pointer) => {
        const { deliveryAddresses, billAddresses } = this.state
        this.ChangeActionMode(value, editMode);
        $(`#detailClientModal`).modal("hide");
        this.setState({
            addressModel: Object.assign({}, pointer === 1 ? deliveryAddresses[index] : billAddresses[index]),
            auxAddressModel: Object.assign({}, pointer === 1 ? deliveryAddresses[index] : billAddresses[index]),
            pointer: pointer
        })
        $(`#newAddressModal`).modal("show");
    }

    NewAddress = async (value, editMode, pointer) => {
        $("#detailClientModal").modal("hide");
        this.ChangeActionMode(value, editMode);
        this.setState({
            addressModel: new Addresses(),
            pointer: pointer
        })
        $("#newAddressModal").modal("show");
    }

    SendAddress = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { addressModel, Action, updatebusinessPartner, pointer } = this.state
        if (await this.ValidateAddress() === false) return
        let data = {
            Action: Action,
            CardCode: updatebusinessPartner.CardCode,
            addressModel,
            pointer,
        };
        enableSpinner(true);
        let responseApi = await apiClient.SendAddressCounter(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'warning', message: responseApi.message });
            return;
        }
        showAlert({ type: 'success', message: responseApi.message });
        this.GetPartnerAddresses(updatebusinessPartner.CardCode);
        $("#newAddressModal").modal("hide");
        $(`#detailClientModal`).modal("show");
    }

    SetIndexBillDirection = (index) => {
        const { newOrderModel, billAddresses } = this.state;

        newOrderModel.PayToCode = billAddresses[index].Address
        this.setState({ setBillIndex: index })
    }

    SetIndexDeliveryDirection = (index) => {
        const { newOrderModel, deliveryAddresses } = this.state;
        newOrderModel.ShipToCode = deliveryAddresses[index].Address;
        this.setState({
            setDeliveryIndex: index
        })
    }

    ValidateAddress = () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { addressModel } = this.state;
        let flag = true;
        if (addressModel.Address === '') {
            showAlert({ type: 'warning', message: 'El identificador de la dirección esta vació.' });
            flag = false;
        }
        if (addressModel.Street === '') {
            showAlert({ type: 'warning', message: 'El campo calle y número esta vació.' });
            flag = false;
        }
        if (addressModel.Block === '') {
            showAlert({ type: 'warning', message: 'El campo colonia esta vació.' });
            flag = false;
        }
        if (addressModel.City === '') {
            showAlert({ type: 'warning', message: 'El campo ciudad esta vació.' });
            flag = false;
        }
        if (addressModel.ZipCode === '') {
            showAlert({ type: 'warning', message: 'El campo código postal esta vació.' });
            flag = false;
        }
        if (addressModel.County === '') {
            showAlert({ type: 'warning', message: 'El campo estado esta vació.' });
            flag = false;
        }
        if (addressModel.Country === '') {
            showAlert({ type: 'warning', message: 'El campo país esta vació.' });
            flag = false;
        }
        return flag;
    }

    UploadInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ordersToAction, idWorkShift, folio, newOrderModel, _user } = this.state
        const infoFolio = await _generalFunctions.getDocInfoByFolio(folio)

        const invoiceSeries = _user?.U_FMB_ValidateSeriesOINV.split("|")
        if (invoiceSeries) {
            for (let index = 0; index < invoiceSeries.length; index++) {
                const serie = invoiceSeries[index];
                if (index === 0) {
                    newOrderModel.SerieCode = serie;
                    break;
                }
            }
        }

        const returnsSeries = _user?.U_FMB_ValidateSeriesORDN.split("|")
        if (invoiceSeries) {
            for (let index = 0; index < returnsSeries.length; index++) {
                const serie = returnsSeries[index];
                if (index === 0) {
                    newOrderModel.ReturnSerieCode = serie;
                    break;
                }
            }
        }

        const creditNotesSeries = _user?.U_FMB_ValidateSeriesORIN.split("|")
        if (invoiceSeries) {
            for (let index = 0; index < creditNotesSeries.length; index++) {
                const serie = creditNotesSeries[index];
                if (index === 0) {
                    newOrderModel.CreditNotesSeries = serie;
                    break;
                }
            }
        }


        const data = {
            ordersToAction,
            infoFolio,
            idWorkShift,
            newOrderModel,
            Folio: folio,
            Time: moment().format(),
        }

        enableSpinner(true);
        const responseApi = await apiClient.createInvoiceCounter(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message}`, timeOut: 10000 });
        $("#detailClientModal").modal("hide");
        await this.ShowCreatedInvoice(responseApi.data.createdFolio, false, responseApi.data.timbraResponse);
    }

    ShowCreatedInvoice = async (document, beforeEdit, timbraResponse = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (!beforeEdit) {
            const data = {
                docsToPrintIds: [document],
                typeDoc: 13
            }
            enableSpinner(true);
            let responseApi = await apiClient.getPrintDocsInfo(data);
            enableSpinner(false);

            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                return;
            }

            for (let index = 0; index < responseApi.data.length; index++) {
                const document = responseApi.data[index];
                if (timbraResponse && index === 0 && timbraResponse.status) {
                    showAlert({ type: "success", message: `${timbraResponse.message}` });
                    document.docHeader.responseHeader.U_FMB_XMLTIMBRA = JSON.stringify(timbraResponse.XML);
                } else if (timbraResponse && !timbraResponse.status) {
                    showAlert({ type: "error", message: `Documento no timbrado` });
                    showAlert({ type: "info", message: `${timbraResponse.message}`, timeOut: 10000 });
                }
            }

            await this.setState({
                docsToPrint: responseApi.data ?? [],
                typeDoc: 'OINV',
                ordersToAction: document,
                EnableEditButton: false,
                showPDFViewer: !this.state.showPDFViewer,
                ShowExtraActions: timbraResponse && timbraResponse.status ? true : false
            });

            $("#pdfViewer").modal("show");
        }
    }

    validateRebilling = async () => {
        const { folioToSearch } = this.state;
        if (folioToSearch.substring(3, 5) === "IV") {
            await this.setState({ showWarningModal: true });
            $("#warningModal").modal("show");
            $("#warningModal").on("hidden.bs.modal", async () => { await this.setState({ showWarningModal: false }); });
        } else { this.Rebilling(); }
    }

    Rebilling = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { folioToSearch, docs } = this.state
        // if (this.state.partnerSearch === '') {
        //     showAlert({ type: "info", message: `NO HAS SELECCIONADO UN DOCUMENTO A FACTURAR` });
        //     return;
        // }

        if (docs.length > 1) return showAlert({ timeOut: 5000, type: "info", message: `BUSCA EL DOCUMENTO QUE DESEES FACTURAR AGREGANDO EL FOLIO AL CAMPO: Doc. Folio` });

        if (folioToSearch !== '') {
            const data = {
                ReturnFolio: folioToSearch,
            }

            enableSpinner(true);
            const responseApi = await apiClient.getReturnFolioAmount(data);
            // im not put right here the enableSpinner(false) because the sensation user its better put the the spinner false after the validations

            if (responseApi.status !== 1) {
                enableSpinner(false);
                showAlert({ type: "error", message: `ALGO SALIO MAL AL BUSCAR LA INFORMACIÓN DE TU DOCUMENTO` });
                return;
            }

            if (responseApi.data.infoReturn) {
                if (responseApi.data.infoReturn.paidOut && responseApi.data.infoReturn.paidOut === 'N') {
                    enableSpinner(false);
                    showAlert({ type: "warning", message: `ESTE DOCUMENTO NO ESTA PAGADO NO SE PUEDE FACTURAR`, timeOut: 4000 });
                    return
                }

                await this.GetDataPartner();
                await this.SearchPartners();
                enableSpinner(false);
            } else {
                enableSpinner(false);
                showAlert({ type: "warning", message: `ERROR INESPERADO AL CONSULTAR LA INFORMACIÓN DE TU DOCUMENTO`, timeOut: 4000 });
                return
            }

        }
    }




    //#endregion
    GotoDashboard = () => {
        this.props.history.push("/");
    };

    //#region ########## CASH CUT #########################################################
    GetBoxCut = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;
        enableSpinner(true);
        let responseApi = await apiClient.partialCut(idWorkShift);

        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        this.setState({
            cashCut: responseApi.data.reportcashCut || "",
            totalCashCut: Number(responseApi.data.totalCashCut) || 0,
            TotalAmountSales: Number(responseApi.data.totalAmountSales) || 0,
            numSalesCashCut: Number(responseApi.data.numSales) || 0,
            objCharge: responseApi.data.objCharge || {},
            extraPaymentsCashCut: responseApi.data.extraPayments,
            moneyOuts: responseApi.data.moneyOuts,
            moneyEntries: responseApi.data.moneyEntries
        });
    };

    InsertWorkShiftT = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let responseApi = await apiClient.insertWorkShiftT();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        if (responseApi.status === 0) {
            await this.GotoDashboard();
        }
        this.setState({ idWorkShift: responseApi.data.idSession });
    };

    CloseWorkShift = async (blindInfoModel) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;
        const data = {
            idWorkShift,
            blindInfoModel
        }

        enableSpinner(true);
        const responseApi = await apiClient.closeWorkShiftT(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });

            return false;
        }
        showAlert({ type: "info", message: `${responseApi.message}` });
        $("#totalModal").modal("show");
        await this.setState({
            lastDaySession: false,
            ReturnedBlindCut: responseApi.ReturnedBlindCut || [],
        })
        return true;
    };

    SendToLogin = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        showAlert({ type: "info", message: `ESTAS SIENDO REDIRIGIDO AL LOGIN. ESTO ES PLANEADO.`, timeOut: 99999 });
        localStorage.removeItem(config.localStorageNamed + 'Token');
        localStorage.removeItem(config.localStorageNamed + 'currentUser');
        localStorage.removeItem(config.localStorageNamed + 'toogleNavBarItem');
        socketService.emit('logout', '');
        // const existStorage = localStorage.getItem(config.localStorageNamed + 'currentUser');
        this.props.history.push('/');
        this.props.history.push('/login');
        window.location.reload(true);
    }

    //#endregion

    ValidateAuthorization = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, idWorkShift, folio, ordersToAction } = this.state;
        if (newOrderModel.isDocumentWithAuthorization) {
            return false;
        }

        const infoFolio = await _generalFunctions.getDocInfoByFolio(folio)
        const data = {
            ordersToAction,
            infoFolio,
            idWorkShift,
            newOrderModel,
            Folio: folio,
            Time: moment().format(),
        }

        enableSpinner(true);
        let response = await apiClient.autorizationInvoiceModels(data);
        enableSpinner(false);
        let autorization = [];
        if (response.status === 1) {
            let respo = response.autorization;
            for (let i = 0; i < respo.length; i++) {
                const element = respo[i];
                autorization.push({
                    name: element.nameCond,
                    id: element.wtm,
                    comment: '',
                });
            }

            let autho = {};
            autorization = autorization.filter((element) => autho[element.id] ? false : autho[element.id] = true);
            this.setState({
                AuthorizationComments: autorization,
            });
            $('#authorizationModel').modal('show');
            return true;
        } else {
            return false;
        }
    }
    selectTable = (view = null, docTypeMiddleware = null) => {
        let name = "";
        let complement = "";
        let docSubType = "";
        let docType = "";
        let name2 = "";
        let complement2 = "";
        let docSubType2 = "";
        let docType2 = "";
        let reserveInvoice = "N";

        switch (view) {
            case "quotations":
                name = "OQUT";
                complement = "QUT1";
                docSubType = "--";
                docType = "23";
                reserveInvoice = "N";
                break;
            case "orderSales":
                name = "ORDR";
                complement = "RDR1";
                docSubType = "--";
                docType = "17";
                reserveInvoice = "N";
                break;
            case "deliveries":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "deliveries2":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "deliveries3":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "invoice":
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                reserveInvoice = "N";
                break;
            case "invoiceReserve":
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                reserveInvoice = "Y";
                break;
            case "return":
                name = "ORDN";
                complement = "RDN1";
                docSubType = "--";
                docType = "16";
                reserveInvoice = "N";
                break;
            case "debitNote":
                name = "OINV";
                complement = "INV1";
                docSubType = "DN";
                docType = "13";
                reserveInvoice = "N";
                break;
            case "creditNote":
                name = "ORIN";
                complement = "RIN1";
                docSubType = "--";
                docType = "14";
                reserveInvoice = "N";
                break;
            case "downPayments":
                name = "ODPI";
                complement = "DPI1";
                docSubType = "--";
                docType = "203";
                reserveInvoice = "N";
                break;
            case "PurchaseOrder":
                name = "OPOR";
                complement = "POR1";
                docSubType = "--";
                docType = "22";
                break;
            case "purchaseReturn":
                name = "ORPD";
                complement = "RPD1";
                docSubType = "--";
                docType = "21";
                break;
            case "GoodsReceipt":
                name = "OPDN";
                complement = "PDN1";
                docSubType = "--";
                docType = "20";
                break;
            case "PurchaseRequest":
                name = "OPRQ";
                complement = "PRQ1";
                docSubType = "--";
                docType = "1470000113";
                break;
            case "purchaseInvoice":
                name = "OPCH";
                complement = "PCH1";
                docSubType = "--";
                docType = "18";
                break;
            case "purchaseCreditNotes":
                name = "ORPC";
                complement = "RPC1";
                docSubType = "--";
                docType = "19";
                break;




            case "transfers":
                name = "OWTR";
                complement = "WTR1";
                docSubType = "--";
                docType = "67";
                break;
            case "transfersRequest":
                name = "OWTQ";
                complement = "WTQ1";
                docSubType = "--";
                docType = "1250000001";
                break;
            case "transfersEntry":
                name = "OIGN";
                complement = "IGN1";
                docSubType = "--";
                docType = "59";
                break;
            case "transfersOutput":
                name = "OIGE";
                complement = "IGE1";
                docSubType = "--";
                docType = "60";
                break;
            case "bussinesPartner":
                name = "OCRD";
                complement = "CRD1";
                docSubType = "--";
                break;
            case "inventoryRevaluation":
                name = "OMRV";
                complement = "MRV1";
                docSubType = "--";
                docType = "162";
                break;
            case "payment":
                name = "ORCT";
                complement = "RCT1";
                docSubType = "--";
                docType = "24";
                break;
            case "outgoingPayment":
                name = "OVPM";
                complement = "VPM1";
                docSubType = "--";
                docType = "30";
                break;
            case "invoiceBorrador":
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
            case "invoiceAuthorization":
                name = "OWDD";
                complement = "OWDD";
                docSubType = "--";
                break;

            case "deliveries4":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;


            default:
                name = "";
                complement = "";
                docSubType = "";
                docType = "13";
        }

        return {
            name,
            complement,
            docSubType,
            docType,
            name2,
            complement2,
            docSubType2,
            docType2,
            reserveInvoice,
        };
    };
    printDocsSUNAT = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { docsToPrint } = this.state
        const documents = [
            ...new Map(
                docsToPrint.map(doc => {
                    const DocEntry = doc.docHeader?.responseHeader?.DocEntry ?? doc.header?.DocEntry;
                    const ObjType = doc.docHeader?.responseHeader?.ObjType ?? doc.header?.ObjType;

                    return [
                        `${DocEntry}-${ObjType}`,
                        { DocEntry, ObjType }
                    ];
                })
            ).values()
        ];
        enableSpinner(true);
        const responseApi = await apiClient.printSunatDocs({ documents, action: 'print' });
        enableSpinner(false);
        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            try {
                const pdfViewer = document.getElementById('pdfPrinterViewer');

                if (!pdfViewer) {
                    return showAlert({
                        type: 'error',
                        message: 'No puedes visualizar el PDF'
                    });
                }

                const base64 = responseApi?.data?.[0]?.file;

                if (!base64) {
                    return showAlert({
                        type: 'error',
                        message: 'No se encontró el archivo PDF'
                    });
                }

                pdfViewer.innerHTML = `
                        <div style="
                            background:#2b2b2b;
                            padding:20px;
                            border-radius:10px;
                            height:100%;
                        ">
                            <iframe 
                                src="data:application/pdf;base64,${base64}"
                                style="width: 100%; height: 100%; border: none;">
                            </iframe>
                        </div>
                    `;



                $("#printDocumentsModal").modal("show");

            } catch (error) {
                return showAlert({ type: 'error', message: error.message ?? 'No puedes visualizar el PDF CTCH' });

            }
        } else {
            return showAlert({ type: 'error', message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", timeOut: 10000 });
        }
    }

    printCesionEnUso = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { docsToPrint } = this.state;

        const documents = [
            ...new Map(
                docsToPrint.map(doc => {
                    const DocEntry = doc.docHeader?.responseHeader?.DocEntry ?? doc.header?.DocEntry;
                    const ObjType = doc.docHeader?.responseHeader?.ObjType ?? doc.header?.ObjType;
                    return [
                        `${DocEntry}-${ObjType}`,
                        { DocEntry, ObjType }
                    ];
                })
            ).values()
        ];

        enableSpinner(true);
        const responseApi = await apiClient.printCesionEnUsoDocs({ documents, action: 'print' });
        enableSpinner(false);

        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            try {
                const pdfViewer = document.getElementById('pdfPrinterViewer');

                if (!pdfViewer) {
                    return showAlert({ type: 'error', message: 'No puedes visualizar el PDF' });
                }

                const base64 = responseApi?.data?.[0]?.file;

                if (!base64) {
                    return showAlert({ type: 'error', message: 'No se encontró el archivo PDF' });
                }

                pdfViewer.innerHTML = `
                <div style="background:#2b2b2b; padding:20px; border-radius:10px; height:100%;">
                    <iframe 
                        src="data:application/pdf;base64,${base64}"
                        style="width: 100%; height: 100%; border: none;">
                    </iframe>
                </div>
            `;

                $("#printDocumentsModal").modal("show");

            } catch (error) {
                return showAlert({ type: 'error', message: error.message ?? 'No puedes visualizar el PDF' });
            }
        } else {
            return showAlert({ type: 'error', message: responseApi?.message || "Ocurrió un error inesperado", timeOut: 10000 });
        }
    }

    ShowFormatToPrint = async () => {
        await this.setState({
            printhide: !this.state.printhide,
        });
    };

    selectTip = () => {
        const { typeDoc } = this.state;
        const { Sales, Invoices } = tips;
        const sales = ['DL', 'DH'];
        const invoices = ['IVH', 'IV', 'IVR'];

        switch (true) {
            case sales.includes(typeDoc):
                return Sales;
            case invoices.includes(typeDoc):
                return Invoices;
            default:
                return [];
        }
    }

    formatSapTime = (time) => {
        if (!time) return '';

        const value = time.toString().padStart(4, '0');

        const hours = value.slice(0, 2);
        const minutes = value.slice(2, 4);

        return `${hours}:${minutes}`;
    };

    render() {
        const itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        const {
            initialDate,
            finalDate, docs,
            folio, cardCode,
            checkboxDataTables, showPDFViewer,
            docsToPrint, typeDoc, sendMailModel,
            venta, _user, partnerSearch,
            partnerIndex, businessPartners,
            businessPartner, groupNumList,
            editModePartner, updatebusinessPartner,
            deliveryAddresses, billAddresses,
            setDeliveryIndex, setBillIndex,
            NextStepFunction, ItsComingOfRebilling,
            newOrderModel, actionButton, FlowOrigin,
            CanChangePartner, Action, addressModel, auxAddressModel,
            showInitialCashModal, searchByBO,
            showCashCutModal, cashCut, objCharge, totalCashCut, TotalAmountSales, numSalesCashCut, extraPaymentsCashCut, moneyEntries, moneyOuts,
            lastDaySession, printhide,
            AuthorizationComments, CFDI,
            RegimenFiscal, ReturnedBlindCut,
            pointer, taxes, states, countries, showWarningModal,
            bankOptions = [],
            ticketDocType, ticketOptions,
        } = this.state
        const { notificationReducer: { showAlert } } = this.props;

        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
        }

        let mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }

        const DetailPartnerTools = {
            deliveryAddresses,
            billAddresses,
            setBillIndex,
            setDeliveryIndex,
            NewAddress: this.NewAddress,
            SetIndexBillDirection: this.SetIndexBillDirection,
            SetIndexDeliveryDirection: this.SetIndexDeliveryDirection,
            EditAddress: this.EditAddress,
            RefreshAddressModel: this.RefreshAddressModel,
            SendAddress: this.SendAddress,
            FlowOrigin,
            Action,
            pointer,
            taxes,
            addressModel,
            auxAddressModel
        }

        const { showBillingBtn } = this.state;

        return (
            <div className="content">
                <NavBar props={this.props} itemsDashboard={itemsDashboard} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'REIMPRESIÓN'} url1={'#'} />
                <div style={{ marginLeft: "4rem" }}>
                    <div>
                        <div className="row m-3">
                            <h3 className="ml-3 mb-2 mt-3" id="refundModalLabel">Imprimir Documento</h3>
                        </div>
                        <div className="container-fluid mt-3">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row p-1">
                                        <div className="col-12 col-md-4 mb-2 responsive-row">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text" id="basic-addon1"><strong>Documentos: </strong></span>
                                                </div>
                                                <select
                                                    id="toggleCostumer"
                                                    className="form-control"
                                                    onChange={(event) => this.OnchangeTypeDoc(event.target.value)}
                                                    value={typeDoc}
                                                >
                                                    <option value={''}>Seleccione una opción: </option>
                                                    {
                                                        venta.map((option, index) => {
                                                            return (
                                                                <option key={index} value={option.value.trim()}> {option.name}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-3 mb-2 responsive-row">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>Doc. Folio: </strong></span>
                                                </div>
                                                <input
                                                    type="text" className="form-control"
                                                    value={folio ?? ''}
                                                    onKeyPress={(ev) => { if (ev.key === 'Enter') { this.SearchPrintReports() } }}
                                                    onChange={(event) => this.OnchangeFolio(event.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-3 text-left mb-2 responsive-row">
                                            {(typeDoc === 'DL' || typeDoc === 'DH' || showBillingBtn) && docs?.length > 0 &&
                                                <button type="button" className="btn btn-primary" onClick={this.validateRebilling}>
                                                    <i className="fa fa-file-text  mr-2" aria-hidden="true" />
                                                    Facturación
                                                    {this.selectTip().length > 0 &&
                                                        <span className="d-inline-block">
                                                            <ToolTip tips={this.selectTip()} position={'up'} />
                                                        </span>
                                                    }
                                                </button>
                                            }
                                            {(typeDoc === 'IV' || typeDoc === 'TCK') && docs?.length > 0 &&
                                                <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    onClick={this.ReprintSelectedTickets}
                                                >
                                                    <i className="fa fa-ticket mr-2" aria-hidden="true" />
                                                    Reimprimir ticket
                                                </button>
                                            }

                                        </div>
                                        <div className='col-12 col-md-2 text-right mb-2 responsive-row'>
                                            <button type="button" className="btn btn-primary pl-3 pr-3" onClick={() => this.SendToPrint()}>
                                                <i className="fa fa-print  mr-2" aria-hidden="true" />
                                                Imprimir
                                            </button>
                                        </div>

                                    </div>
                                    {typeDoc === 'TCK' &&
                                        <div className="row p-1">
                                            <div className="col-12 col-md-4 mb-2 responsive-row">
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"><strong>Tipo de Tiket: </strong></span>
                                                    </div>
                                                    <select
                                                        id="toggleTicketType"
                                                        className="form-control"
                                                        onChange={(event) => this.OnchangeTicketDocType(event.target.value)}
                                                        value={ticketDocType}
                                                    >
                                                        <option value={''}>Seleccione una opción: </option>
                                                        {
                                                            ticketOptions.map((option, index) => {
                                                                return (
                                                                    <option key={index} value={option.value}> {option.name}</option>
                                                                );
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="row p-1">

                                        <div className="col-12 col-md-4 mb-2 responsive-row">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>Código del cliente: </strong></span>
                                                </div>
                                                <input
                                                    type="text" className="form-control"
                                                    value={cardCode ?? ''}
                                                    onKeyPress={(ev) => { if (ev.key === 'Enter') { this.SearchPrintReports() } }}
                                                    onChange={(event) => this.OnchangeCardCode(event.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-3 mb-2 responsive-row">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>Desde: </strong></span>
                                                </div>
                                                <input
                                                    type="date" className="form-control"
                                                    onKeyPress={(ev) => { if (ev.key === 'Enter') { this.SearchPrintReports() } }}
                                                    value={initialDate}
                                                    max={finalDate}
                                                    onChange={(event) => this.ChangeInitialDate(event)}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-3 mb-2 responsive-row">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>Hasta: </strong></span>
                                                </div>
                                                <input
                                                    type="date" className="form-control"
                                                    onKeyPress={(ev) => { if (ev.key === 'Enter') { this.SearchPrintReports() } }}
                                                    value={finalDate}
                                                    max='9999-12-31'
                                                    onChange={(event) => this.ChangeFinalDate(event)}
                                                />
                                            </div>
                                        </div>

                                        {/* <div className='col-md-2'>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text"><strong>Buscar solo sucursal: </strong></span>
                                                </div>
                                                <input
                                                    type="checkbox" className="form-control"
                                                    checked={searchByBO}
                                                    onChange={() => this.ChangeSearchByBranchOffice()}

                                                />
                                            </div>
                                        </div> */}

                                        <div className="col-12 col-md-2 text-right mb-2 responsive-row">
                                            <button type="button" className="btn btn-primary" onClick={() => this.SearchPrintReports()} style={{ backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)" }}>
                                                <i className="fa fa-search mr-2" aria-hidden="true" />
                                                Buscar
                                            </button>
                                        </div>
                                    </div>
                                    <div className='m-3'>
                                        <div className='card scrollTableRePrint' >
                                            <table className="table table-striped table-hover">
                                                <thead className='sticky-headerPOS' style={{ background: "white" }}>
                                                    <tr>
                                                        <th className="text-center"></th>
                                                        <th className="text-center">Folio</th>
                                                        <th className="text-center">No.Ref.de. cliente</th>
                                                        <th className="text-center">Fecha</th>
                                                        <th className="text-center">Hora</th>
                                                        {/* <th className="text-center">Estación</th> */}
                                                        <th className="text-center">Doc. Status</th>
                                                        {typeDoc !== 'MI' && typeDoc !== 'MO' && !(typeDoc === 'TCK' && ticketDocType === 'transfersOutput') && <th className="text-center">CardCode</th>}
                                                        {typeDoc !== 'MI' && typeDoc !== 'MO' && !(typeDoc === 'TCK' && ticketDocType === 'transfersOutput') && <th className="text-center">Nombre de cliente</th>}
                                                        <th className="text-center">Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {docs.length > 0 &&
                                                        docs.map((doc, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td className="text-center" onClick={() => checkbox.selectOne(index)}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={!!checkbox.data.get(index)}
                                                                            readOnly
                                                                        // onChange={(event) => checkbox.selectOne(index)} 
                                                                        />
                                                                    </td>
                                                                    <td className="text-center">{doc.folio}</td>
                                                                    <td className="text-center">
                                                                        {typeDoc === 'GRE'
                                                                            ? (() => {
                                                                                const serie = doc.U_BPP_MDSD || '';
                                                                                const correlativo = doc.U_BPP_MDCD || '';
                                                                                if (serie && correlativo) return `${serie}-${correlativo}`;
                                                                                if (serie) return serie;
                                                                                if (correlativo) return correlativo;
                                                                                return '';
                                                                            })()
                                                                            : (typeDoc === 'IVCU' || typeDoc === 'IP')
                                                                                ? this.BuildCertificateReference(doc, typeDoc)
                                                                                : typeDoc === 'TCK'
                                                                                    ? (doc.U_BPP_MDTD || doc.U_BPP_MDSD || doc.U_BPP_MDCD)
                                                                                        ? `${doc.U_BPP_MDTD ?? ''}-${doc.U_BPP_MDSD ?? ''}-${doc.U_BPP_MDCD ?? ''}`.replace(/-+/g, '-')
                                                                                        : ''
                                                                                    : doc.NumAtCard || ''
                                                                        }
                                                                    </td>
                                                                    <td className="text-center">{moment(doc.docDate).format('YYYY-MM-DD')}</td>
                                                                    <td className="text-center">{(typeDoc === 'IV' || typeDoc === 'TCK') ? this.formatSapTime(doc.docTime) : doc.docTime && doc.docTime.toString().length > 4 ? doc.docTime : moment(doc.docTime).format('LT')}</td>
                                                                    {/* <td className="text-center">AOC</td> */}
                                                                    <td className="text-center">{doc.docStatus === 'C' ? 'Cerrado' : 'Abierto'}</td>
                                                                    {typeDoc !== 'MI' && typeDoc !== 'MO' && !(typeDoc === 'TCK' && ticketDocType === 'transfersOutput') && <td className="text-center">{doc.cardCode}</td>}
                                                                    {typeDoc !== 'MI' && typeDoc !== 'MO' && !(typeDoc === 'TCK' && ticketDocType === 'transfersOutput') && <td className="text-center">{doc.CardName}</td>}
                                                                    <td className="text-center">{(doc.docCur || CURRENCY) + ' ' + formatNumber.new(doc.docTotal)}</td>
                                                                </tr>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    {/* <div className='row mt-5 mr-3'>
                                        <div className='col-12 text-right'>
                                            <button type="button" className="btn btn-primary" onClick={() => this.SendToPrint()}>
                                                <i className="fa fa-print  mr-2" aria-hidden="true" />
                                                Imprimir
                                            </button>
                                        </div>

                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showPDFViewer &&
                    <PdfViewer
                        DocsToPrint={docsToPrint}
                        TypeDoc={typeDoc}
                        DLR={this.state.typeDoc2}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={() => { }}
                        EditableDocModel={{}}
                        RefreshDocModel={() => { }}
                        SaveChanges={() => { }}
                        UploadDoc={() => { }}
                        EditParam1={false}
                        OnchangePDfViewer={this.OnchangePDfViewer}
                        ShowPDFViewer={this.CleanCheckedList}
                        OpenMailModal={this.OpenSendMailModal}
                        MailTools={mailTools}
                        user={_user}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                        tckfolio={newOrderModel.TckFolio}
                        reprint={true}
                        time={moment(new Date()).format('HH:mm:ss')}
                        today={moment(new Date()).format('YYYY-MM-DD')}
                        RegisterReprint={() => this.RegisterReprint(docsToPrint)}
                        printDocsSUNAT={this.printDocsSUNAT}
                        printCesionEnUso={this.printCesionEnUso}
                    // sendMailModel={sendMailModel}
                    // sendDocsMail={this.sendDocsMail}
                    />
                }
                <PrintDocumentsModal />

                <ClientsModal
                    partnerSearch={partnerSearch}
                    EnableClientsModal={this.EnableClientsModal}
                    ChangePartnerSearch={this.ChangePartnerSearch}
                    SearchPartners={this.SearchPartners}
                    partnerIndex={partnerIndex}
                    businessPartners={businessPartners}
                    SelectBusinessPartner={this.SelectBusinessPartner}
                    SelectPartnerIndex={this.SelectPartnerIndex}
                    businessPartner={businessPartner}
                    RefreshBusinessPartner={this.RefreshBusinessPartner}
                    showAlert={showAlert}
                    GetDataPartner={this.GetDataPartner}
                    groupNumList={groupNumList}
                    priceList={[]}
                    groupCodeList={[]}
                    CreateBusinessPartner={this.CreateBusinessPartner}
                    clearData={() => this.setState({ /*groupNumList: [], businessPartner: {}, businessPartners: [], */ })}
                    EditBusinessPartner={this.EditBusinessPartner}
                    editMode={editModePartner}
                    ChangeCardName={this.ChangeCardName}
                    ChangeCellular={this.ChangeCellular}
                    ChangeCreditLine={this.ChangeCreditLine}
                    ChangeExtraDays={this.ChangeExtraDays}
                    ChangeE_mail={this.ChangeE_mail}
                    UpdateBusinessPartner={this.UpdateBusinessPartner}
                    updatebusinessPartner={updatebusinessPartner}
                    DetailPartnerTools={DetailPartnerTools}
                    ShowDetailClientModal={this.ShowDetailClientModal}
                    NextStepFunction={NextStepFunction}
                    ItsComingOfRebilling={ItsComingOfRebilling}
                    RefreshBusinessModel={this.RefreshBusinessModel}
                    GroupNumList={groupNumList}
                    newOrderModel={newOrderModel}
                    actionButton={actionButton}
                    CanChangePartner={CanChangePartner}
                    ShowClientsModalReBilling={this.ShowChooseDifPartner}
                    CFDI={CFDI}
                    RegimenFiscal={RegimenFiscal}
                    ChangeUSOCFDI={this.ChangeUSOCFDI}
                    ChangeRegimenFiscal={this.ChangeRegimenFiscal}
                    Change_MetodoPago={this.Change_MetodoPago}
                    Change_Tipo_Relacion_CFDI={this.Change_Tipo_Relacion_CFDI}
                    ChanceTemporalDataToFalse={this.ChanceTemporalDataToFalse}
                    view={'rePrint'}
                    refreshModel={this.refreshModel}
                    countries={countries}
                    states={states}
                />

                {showInitialCashModal && (
                    <InitialCashModal
                        InsertWorkShiftT={this.InsertWorkShiftT}
                        CancelWorkShift={this.GotoDashboard}
                    />
                )}
                {AuthorizationComments.length > 0 &&
                    <AuthorizationModel
                        newOrderModel={newOrderModel}
                        comments={AuthorizationComments}
                        updateComments={this.updateCommentsAuthorizationModel}
                        createDocument={() => this.CreateDocument(true)} />
                }

                {showCashCutModal && (
                    <CashCutModal
                        ShowCashCutModal={this.ShowCashCutModal}
                        CashCut={cashCut}
                        ObjCharge={objCharge}
                        TotalCashCut={totalCashCut}
                        TotalAmountSales={TotalAmountSales}
                        NumVentas={numSalesCashCut}
                        extraPaymentsCashCut={extraPaymentsCashCut}
                        moneyEntries={moneyEntries}
                        moneyOuts={moneyOuts}
                        headerCashCut={{ U_NAME: "", docUpdate: "", endSession: "" }}
                        BranchOfficeGeneralCut={() => { }}
                        CloseWorkShift={this.CloseWorkShift}
                        GotoDashboard={this.SendToLogin}
                        lastDaySession={lastDaySession}
                        _user={_user}
                        blindCashCut={true}
                        ReturnedBlindCut={ReturnedBlindCut}
                        BlindCutByIdSession={[]}
                        bankOptions={bankOptions}
                    />
                )}

                {showWarningModal &&
                    <WarningModal
                        title='Advertencia'
                        message='El documento seleccionado ya es una factura, ¿Desea Re-Facturar el documento?'
                        btnAccept='Continuar'
                        btnCancel='Cancelar'
                        size='modal-md'
                        accept={this.Rebilling}
                        cancel={() => { }} />
                }

            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RePrintView);
